<template>
  <div class="search-page">
    <div class="top-page-all">
      <div @click="onClickLeft" class="ret-btn"><</div>
      <div>我的客户列表</div>
    </div>
    <div class="top-bg-st"></div>
    <div class="search-clr">
      <div class="search-box">
        <input v-model="phone" placeholder="请输入手机号" type="text">
        <span @click="searchPhone">搜索用户</span>

      </div>
      <template v-if="mid">
        <van-cell-group>
          <van-field

            v-model="info.realname"
            disabled
            clearable
            label="用户名"
            placeholder=""
          />
          <van-field
            disabled
            v-model="info.phone"
            type="phone"
            label="手机号"
            placeholder=""
          />


          <van-field
            disabled
            v-model="typeLabel"
            label="类型"
            readonly="readonly"
            placeholder=""
          />
          <van-popup :style="{width:'100%'}" position="bottom" v-model="typeShow">
            <van-picker disabled :columns="selectList" @change="onChange"/>
          </van-popup>


          <van-field
            disabled
            v-model="ridLabel"
            label="种类"
            readonly="readonly"
            placeholder=""
          />
          <van-popup :style="{width:'100%'}" position="bottom" v-model="ridShow">
            <van-picker :columns="ridList" @change="onChangeRid"/>
          </van-popup>


          <van-field
            v-model="info.remarks"
            disabled
            rows="3"
            autosize
            label="客户备注"
            type="textarea"
            placeholder=""
          />
        </van-cell-group>

      </template>
      <van-panel title="授权书影币">
        <div slot="footer">
          <input placeholder="请输入书影币数量" style="width: 4.8rem;font-size: 14px" type="number" v-model="addMoney">
          <div @click="giveMoney" class="btn-blur">授权书影币</div>
        </div>
      </van-panel>
    </div>
  </div>
</template>

<script>
  import province_list from '@/assets/js/dq.js'

  export default {
    name: "search",
    data() {
      return {
        mid: '',    //用户id
        addMoney: '',
        info: {
          realname: '',
          phone: '',
          rid: '',
          remarks: '',
          type: 0,
          province: '',
          city: '',
          county: '',
          password: '',
        },
        typeLabel: '普通用户',
        ridLabel: '',
        show: false,
        typeShow: false,
        ridShow: false,
        areaList: province_list,
        ridList: [],
        selectList: ['普通用户', '专业个人', '团队', '公司实体'],
        phone: ''
      }
    },
    mounted() {

    },
    methods: {
      searchPhone() {

        if (!this.phone) {
          this.$toast('请输入手机号');
          return
        }
        this.$http.post('userphone', {
          phone: this.phone.trim()
        }).then(
          (res) => {
            if (res.data.code === 200) {
              let data = res.data.data
              console.log(data)
              this.info.realname = data.realname || '';
              this.info.phone = data.phone || '';
              this.info.rid = data.rid || '';
              this.info.remarks = data.remarks || '';
              this.info.type = data.type || '';
              this.mid = data.mid;

              this.onChange('', this.selectList[this.info.type], (this.info.type));
              this.changeType(data.rid);


            } else {
              this.$toast(res.data.msg || '系统错误');
            }
          }, (e) => {
            this.$toast('网络错误');
          }
        )

      },
      giveMoney() {
        let postUrl = 'delegate';
        if (!this.mid) {
          this.$toast('请搜索用户');
          return
        }
        if (!this.addMoney) {
          this.$toast('请输入金额');
          return
        }
        let token = window.localStorage.getItem('token');
        let obj = {
          token: token,
          delegatemoney: this.addMoney,
          mid: this.mid
        };

        this.$http.post(postUrl, obj
        ).then(
          (res) => {
            if (res.data.code === 200) {
              this.delegatemoney = 0;
              this.$toast('授权书影币成功');
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500)
            } else {
              this.$toast(res.data.msg || '系统错误');
            }
          }, (e) => {
            this.$toast('网络错误');
          }
        )
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      addConfirm(picker) {
        this.info.province = picker[0].name;
        this.info.city = picker[1].name;
        this.info.county = picker[2].name;
        this.show = false
      },
      onChangeRid(picker, value) {
        this.info.rid = value.rid;
        this.ridLabel = value.rname;
      },
      onChange(picker, value, index) {
        this.info.type = index;
        this.typeLabel = value;
        if (picker) {
          this.changeType();
        }
      },
      changeType(rid) {
        let type = this.info.type;
        this.ridLabel = '';
        this.ridList = [];
        this.$http.post('memberjb', {
          type: type
        }).then(
          (res) => {
            let list = res.data.data || [];
            let _list = list.map((item, index) => {
              return {...item, text: item.rname, value: item.rid}
            });
            this.ridList = _list;
            if (rid) {
              this.ridList.map((item, index) => {
                item.rid == rid ? this.ridLabel = item.rname : ''
              });
              this.info.rid = rid;
            } else {
              this.ridLabel = this.ridList[0].rname;
              this.info.rid = this.ridList[0].rid;
            }
          }, (e) => {
            this.$toast('网络错误');
          }
        )
      },
    }
  }
</script>

<style lang="scss">
  #app {
    background: #eeeeee;
  }

  .search-page {
    .top-bg-st {
      position: relative;
      height: 2.4rem;
      width: 7.5rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
    }

    .search-clr {
      position: fixed;
      background: #ffffff;
      top: 1.24rem;
      width: 6.86rem;
      padding-bottom: 1.6rem;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      left: 0;
      right: 0;
      margin: 0 auto;
      border-radius: .32rem;
      padding-top: .32rem;

    }

    .submit {
      margin-top: 1rem;
      height: .75rem;
      background: rgba(127, 207, 241, 1);
      font-size: .28rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
    }

    .out-top {
      text-align: center;
      line-height: .98rem;
    }

    .search-box {
      height: 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 .4rem;

      input {
        height: .62rem;
        width: 4.2rem;
        border: 1px solid #ebedf0;
        padding: 0 .2rem;
        box-sizing: border-box;
      }


    }

    .btn-blur {
      border-radius: .12rem;
      margin-top: .12rem;
      padding: .12rem .32rem;
      border-right: .32rem;
      width: 1.6rem;
      background-image: linear-gradient(to right, #038ED1, #1D208A);
      color: #ffffff;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/search.vue